import { jsx as _jsx } from "react/jsx-runtime";
import styles from './ToggleTheme.module.scss';
import classNames from 'classnames';
import { useTheme } from '../../hooks/useTheme';
const DARK = 'dark';
const LIGHT = 'light';
const ToogleButton = () => {
    const { theme, setTheme } = useTheme();
    const handleClick = (e) => {
        if (theme === DARK)
            setTheme('light');
        if (theme === LIGHT)
            setTheme('dark');
    };
    return (_jsx("div", { className: styles.container, onClick: handleClick, children: _jsx("div", { className: classNames(styles.item, { [styles.disabled]: theme === LIGHT }, { [styles.active]: theme === DARK }) }) }));
};
export default ToogleButton;
